define('views/conversations/Podio.Views.Conversations.Chat.ListItem',['require','underscore','lib/backbone/Backbone.PodioView','lib/Podio.UI.Tooltips','jst!conversations/chat/_list_item'],function(require) {

  var _ = require('underscore');
  var PodioView = require('lib/backbone/Backbone.PodioView');
  var Tooltips = require('lib/Podio.UI.Tooltips');

  var jstListItem = require('jst!conversations/chat/_list_item');

  return PodioView.extend({

    tagName: 'li',

    className: function() {
      var classNames = [];

      if (this.model.get('unread_count')) {
        classNames.push('unread');
      }

      // keep the selected class if present
      if (this.elm && this.elm.hasClass('selected')) {
        classNames.push('selected');
      }

      return classNames.length ? classNames.join(' ') : null;
    },

    template: jstListItem,

    podioEvents : {
      'click': 'onConversationClicked'
    },

    initialize: function() {
      _.bindAll(this, 'rerender');

      this._super();
      this._bindEvents();
    },

    _bindEvents: function() {
      this.model.on('change:unread_count', this.rerender);
    },

    rerender: function() {
      _.defer(function(self) {
        // update el's class
        self.elm.attr('class', _.result(self, 'className'));
        self.render();
      }, this);
    },

    render: function() {
      this.elm.attr('data-nav-item' , 'conversation:{0}'.format(this.model.get('id') ? this.model.get('id') : 'placeholder' ));
      this.elm.html(this.getTemplate(this.template, {
        conversation: this.model,
      }));

      return this;
    },

    onConversationClicked: function(elmTarget, e) {
      this.eventBus.trigger('conversation:click', this.model, this);
    },

    dispose: function() {
      this.model.off('change:unread_count', this.rerender);
      this._super();
    }
  });

});

